<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col blue">
          <h3>
            <i class="fas fa-chart-line"></i> Maturity Report
          </h3>
        </div>
        <div class="text-right">
          <label class="custom-toggle">
            <input id="maturityCheck" v-model="maturityBuyOrSell" type="checkbox" @change="setMaturityReportData" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart">
        <canvas id="maturityChart"></canvas>
      </div>
      <a href @click="showPopup" class="view-more">View More<i class="fa fa-arrow-circle-right" ></i></a>
      <!-- <a href class="text-right view-more" @click="showPopup">View More</a> -->
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMore"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Maturity Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
                <!-- <h4>Trade Date Range</h4>
                <form>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">From</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupFromDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">To</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupToDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                </form> -->
              </div>
              <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupMaturityBuyOrSell" @change="setPopupMaturityReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
              <!-- <div class="text-right">
                <label class="custom-toggle">
                  <input
                    v-model="popupMaturityBuyOrSell"
                    type="checkbox"
                    @change="setPopupMaturityReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
              </div> -->
            </div>
            <div class="graph">
              <canvas id="popupMaturityChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getMaturityReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      maturityBuyOrSell: false,
      maturityChartOptions: chartConstants.maturityBarChartDefault,
      maturityChartData: {},
      popupMaturityChartOptions: chartConstants.maturityBarChartDefaultPopup,
      popupMaturityChartData: {},
      popupMaturityBuyOrSell: false,
      myChart : null,
      myChartPoup : null
      // popupFromDate: this.fromdate,
      // popupToDate: this.todate
    };
  },
  methods: {
    getMaturityReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/maturity-date?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.maturityChartData = result.data.data;
          this.setMaturityReportData();
        });
    },
    setMaturityReportData() {
      this.maturityChartOptions.data.labels = this.maturityBuyOrSell ?  this.maturityChartData.sellsYears : this.maturityChartData.buysYears;
      this.maturityChartOptions.data.datasets[0].data = this.maturityBuyOrSell
        ? this.maturityChartData.sells
        : this.maturityChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("maturityChart");
      this.myChart = new window.Chart(ctx, {
        type: this.maturityChartOptions.type,
        data: this.maturityChartOptions.data,
        options: this.maturityChartOptions.options
      });
    },
    getPopupMaturityReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/maturity-date?fromDate=" +
             this.fromdate  +
            "&toDate=" +
             this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.popupMaturityChartData = result.data.data;
          this.setPopupMaturityReportData();
        });
    },
    setPopupMaturityReportData() {
      this.popupMaturityChartOptions.data.labels = this.popupMaturityChartData.years;
      this.popupMaturityChartOptions.data.datasets[0].data = this
        .popupMaturityBuyOrSell
        ? this.popupMaturityChartData.sells
        : this.popupMaturityChartData.buys;
      if(this.myChartPoup){
        this.myChartPoup.destroy();
      }
      const ctx = document.getElementById("popupMaturityChart");
      this.myChartPoup = new window.Chart(ctx, {
        type: this.popupMaturityChartOptions.type,
        data: this.popupMaturityChartOptions.data,
        options: this.popupMaturityChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupMaturityReportData();
      window.$("#chartViewMore").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getMaturityReportData();
      }
    });
  }
};
</script>